export default "__VITE_ASSET__16zWG_bI__"